/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { type AxiosRequestConfig } from 'axios';
import { env } from '$env/dynamic/public';
import { axiosHandler } from '../axiosHandler';

// * This will get all the current conversational feature flags from bumblebee
export async function getAllFlagKeys(params: { brand_code: string, channel: string, email: string, browser_uuid: string, token: string, flag_name?: string }): Promise<Record<string, unknown>> {
    const { brand_code, channel, email = 'nothing@nothing.nothing', browser_uuid, flag_name = '' } = params || {};
    try {
        const config: AxiosRequestConfig = {
            method: 'GET',
            url: `${env.PUBLIC_FLORA_DIRECT}/flags`,
            params: {
                brand_code, channel, email, browser_uuid, ...(flag_name ? { flag_name } : {})
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${params.token}`, },
        };
        const response = await axiosHandler<{ data: Record<string, unknown> }>(config);
        return response?.data?.data
    } catch (error) {
        console.error("Failed to fetch flags:", error);
        return {};
    }
}